import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import { Card, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getPermisos } from 'redux/permisosSlice';
import { getRolByRealEstate } from 'redux/rolesSlice';
import { checkPermission } from 'utils/checkPermission';
import ButtonCreate from 'utils/buttons/ButtonCreate';
import ListaRoles from './ListaRoles';
import CrearRol from './modals/CrearRol';
import EditRol from './modals/EditRol';
import { getRealEstateByUserId } from 'redux/realEstateSlice';

const GestionarRoles = () => {
  const dispatch = useDispatch();

  const listaRoles = useSelector(state => state.roles.data);
  const userLogged = useSelector(state => state.login.currentUser);
  const realEstate = useSelector(state => state.realEstate.realEstate);
  const loadingRoles = useSelector(state => state.roles.loadingRoles);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false); // Nuevo estado

  useEffect(() => {
    dispatch(getPermisos());
    userLogged && dispatch(getRealEstateByUserId(userLogged.id));
  }, [userLogged]);

  useEffect(() => {
    if (realEstate?.id) {
      dispatch(getRolByRealEstate(realEstate.id))
        .then(() => setInitialLoadComplete(true)) // Establecer la primera carga como completa
        .catch(() => setInitialLoadComplete(true)); // También establecer como completa en caso de error
    }
  }, [realEstate]);

  return (
    <>
      <PageHeader
        title="Gestionar Roles y Permisos"
        description="En esta sección puede gestionar los roles y permisos de su inmobiliaria."
        className="mb-3 bg-white"
      >
        {userLogged && checkPermission('Create roles', userLogged) && (
          <ButtonCreate
            className="w-100 w-md-auto"
            text="Nuevo Rol"
            funcion={() => setOpenCreateModal(true)}
            variant="primary"
          />
        )}
      </PageHeader>

      <Card className="bg-white">
        <Card.Header className="d-flex justify-content-between">
          <Card.Title>
            <FontAwesomeIcon
              icon="fa-solid fa-list"
              className="text-dark"
              style={{ marginRight: 10, fontSize: 20 }}
            />
            Lista de roles
          </Card.Title>
        </Card.Header>

        {userLogged && (
          <Card.Body>
            {!initialLoadComplete || loadingRoles ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '600px',
                  paddingBottom: '300px'
                }}
              >
                <Spinner
                  animation="border"
                  style={{
                    color: '#2c7be5'
                  }}
                  role="status"
                />
              </div>
            ) : (
              <ListaRoles
                listaRoles={listaRoles}
                userLogged={userLogged}
                setOpenEditModal={setOpenEditModal}
                realEstate={realEstate}
              />
            )}
          </Card.Body>
        )}
      </Card>

      <CrearRol
        show={openCreateModal}
        setShow={setOpenCreateModal}
        listaRoles={listaRoles}
        realEstate={realEstate}
      />

      <EditRol
        show={openEditModal}
        setShow={setOpenEditModal}
        userLogged={userLogged}
        listaRoles={listaRoles}
        realEstate={realEstate}
      />
    </>
  );
};

export default GestionarRoles;
